import { Box, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'

export function DimensionCardHeader({ title, description, icon, iconBgColor, educationLayout }) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '16px',
        alignItems: 'flex-start',
        width: 360,
        position: educationLayout ? 'absolute' : 'relative',
        left: educationLayout ? 20 : undefined,
        top: educationLayout ? 20 : undefined,
        zIndex: 1,
      }}
    >
      <Box
        sx={{
          width: 52,
          borderRadius: '10px',
          bgcolor: iconBgColor,
          p: '10px',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          component="img"
          src={icon}
          alt=""
          sx={{ width: 32, height: 32, objectFit: 'contain', display: 'block' }}
        />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: 20,
            lineHeight: 1.3,
            color: '#111',
            mb: '4px',
            fontWeight: 400,
          }}
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: 1.5,
            color: 'rgba(17,17,17,0.8)',
          }}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  )
}

export function DimensionCard({
  title,
  description,
  image,
  icon,
  iconBgColor,
  path,
  imageHeight,
  imageScale,
  educationLayout,
  imageRef,
  imageContainerRef,
  sx = {},
}) {
  return (
    <Box
      component={RouterLink}
      to={path}
      sx={{
        width: 400,
        height: 420,
        bgcolor: '#fffefa',
        borderRadius: '20px',
        overflow: 'hidden',
        textDecoration: 'none',
        color: '#111',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: educationLayout ? 0 : '20px',
        pt: educationLayout ? 0 : '20px',
        position: 'relative',
        flexShrink: 0,
        ...sx,
      }}
    >
      <DimensionCardHeader
        title={title}
        description={description}
        icon={icon}
        iconBgColor={iconBgColor}
        educationLayout={educationLayout}
      />

      <Box
        ref={imageContainerRef}
        sx={{
          width: '100%',
          flex: educationLayout || imageHeight ? 'none' : 1,
          height: educationLayout ? 320 : imageHeight ?? 'auto',
          minHeight: educationLayout ? 320 : imageHeight ? imageHeight : 0,
          borderRadius: '20px',
          overflow: 'hidden',
          position: educationLayout ? 'absolute' : 'relative',
          left: educationLayout ? 0 : undefined,
          top: educationLayout ? 100 : undefined,
          mt: educationLayout ? 0 : undefined,
        }}
      >
        <Box
          ref={imageRef}
          component="img"
          src={image}
          alt={title}
          sx={{
            position: 'absolute',
            inset: imageScale ? undefined : 0,
            width: imageScale?.width ?? '100%',
            height: imageScale?.height ?? '100%',
            left: imageScale?.left ?? 0,
            top: imageScale?.top ?? 0,
            maxWidth: 'none',
            objectFit: 'cover',
            display: 'block',
            borderRadius: '20px',
            ...(imageRef ? { opacity: 0 } : {}),
          }}
        />
      </Box>
    </Box>
  )
}

export function MobileDimensionCard({ title, description, image, icon, iconBgColor, path }) {
  return (
    <Box
      component={RouterLink}
      to={path}
      sx={{
        width: '100%',
        bgcolor: '#fffefa',
        borderRadius: '20px',
        overflow: 'hidden',
        textDecoration: 'none',
        color: '#111',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        pt: '20px',
      }}
    >
      <Box sx={{ display: 'flex', gap: '16px', alignItems: 'flex-start', width: '100%', px: '20px' }}>
        <Box
          sx={{
            width: 52,
            borderRadius: '10px',
            bgcolor: iconBgColor,
            p: '10px',
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box component="img" src={icon} alt="" sx={{ width: 32, height: 32, objectFit: 'contain' }} />
        </Box>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Typography sx={{ fontSize: 20, lineHeight: 1.3, color: '#111', mb: '4px' }}>
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: 14,
              lineHeight: 1.5,
              color: 'rgba(17,17,17,0.8)',
            }}
          >
            {description}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ width: '100%', height: { xs: 200, sm: 240 }, overflow: 'hidden', borderRadius: '20px' }}>
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
        />
      </Box>
    </Box>
  )
}
